import { h } from "preact";
import { adjustImage, makeImgUrl } from "../../utils/URL";
function CartImage(props) {
    const { imageUrn } = props;
    const params = { w: 159, h: 768, crop: true };
    const url = adjustImage(params, makeImgUrl(imageUrn));
    return (h("picture", null,
        h("source", { srcset: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", media: "(max-width: 479px)" }),
        h("img", { class: "modal-dialog__image", src: url, alt: "" })));
}
export default CartImage;
